import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    OnInit,
    ElementRef,
    ViewChildren,
    QueryList,
} from '@angular/core';
import { finalize } from 'rxjs/operators';
import {
    CommonLookupServiceProxy,
    SalesInvoiceServiceProxy,
    CreateOrEditSalesDto,
    FindCustomerOutputDto,
    DropDownLookupDto,
    FindProductOutputDto,
    CreateOrEditSalesDetailDto,
    TaxDto,
    GetPurchaseForEditInput,
    Status,
    ApplicableUnitForProduct,
    GetSalesForEditInput,
} from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DateTime } from 'luxon';
import { ActivatedRoute, Router } from '@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Observable } from '@node_modules/rxjs';
import { BreadcrumbItem, SubHeaderComponent } from '@app/shared/common/sub-header/sub-header.component';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

@Component({
    templateUrl: './create-or-edit-salesInvoice.component.html',
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditSalesInvoiceComponent extends AppComponentBase implements OnInit {
    @ViewChildren('itemCodeInput') itemCodeInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('qtyInput') qtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('costInput') costInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('focQtyInput') focQtyInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountPercInput') itemDiscountPercInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('itemDiscountInput') itemDiscountInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('taxInput') taxInputs!: QueryList<ElementRef<HTMLInputElement>>;
    @ViewChildren('addButton') addButtons!: QueryList<ElementRef<HTMLButtonElement>>;
    active = false;
    saving = false;
    customerSelectedItem: FindCustomerOutputDto;
    productSelectedItem: FindProductOutputDto;
    customers: FindCustomerOutputDto[];
    products: FindProductOutputDto[];
    applicableTaxes: TaxDto[];
    units: any[] = [];
    status = Status;

    filterText = '';

    salesInvoice: CreateOrEditSalesDto = new CreateOrEditSalesDto();
    purchaseDetails: CreateOrEditSalesDetailDto[];
    purchaseDetail: CreateOrEditSalesDetailDto = new CreateOrEditSalesDetailDto();

    customerDisplayProperty = '';
    paymentTermName = '';
    totalQty = 0;
    localTotal = 0;
    allPaymentTerms: DropDownLookupDto[];

    breadcrumbs: BreadcrumbItem[] = [
        new BreadcrumbItem(this.l('SalesInvoice'), '/app/sales/salesInvoices'),
        //new BreadcrumbItem(this.l('Entity_Name_Plural_Here') + '' + this.l('Details')),
    ];

    constructor(
        injector: Injector,
        private _activatedRoute: ActivatedRoute,
        private _SalesInvoicesServiceProxy: SalesInvoiceServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _router: Router,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.show(this._activatedRoute.snapshot.queryParams['id']);
        this.addRow(0);
    }

    removeItem(index: number) {
        this.purchaseDetails.splice(index, 1);

        if (this.purchaseDetails.length == 0) {
            this.addRow(index);
        }

        var i = 1;
        this.purchaseDetails.forEach((c) => {
            c.slNo = i++;
        });

        this.productSelectedItem = null;
    }

    searchProduct(productCode: string, data: CreateOrEditSalesDetailDto, index: number) {
        this._commonLookupServiceProxy
            .getProductDetail(undefined, productCode, undefined, 'Sales', this.appSession.user.locationId)
            .subscribe((result) => {
                if (result.productId > 0) {
                    this.focusNext('qty', index);
                    data.productId = result.productId;
                    data.price = result.price;
                    data.productName = result.productName;
                    data.productCode = result.productCode;
                    /*  data.applicableTaxes = result.applicableTaxes;*/
                    data.applicableUnits = result.applicableUnits;
                    data.unitId = result.unitId;
                    data.taxId = result.taxId;
                    data.qty = 1;
                    if (data.productSelectedItem == null) {
                        data.productSelectedItem = new FindProductOutputDto();
                        data.productSelectedItem.id = data.productId;
                        data.productSelectedItem.displayName = data.productName;
                        //this.productSelectedItem.code = result.productCode;
                    }
                    this.changeUnit(data);
                } else {
                    abp.notify.error('ProductNotFound');
                    data.productCode = '';
                }
            });
    }

    focusNext(type: 'qty' | 'price' | 'focQty' | 'itemDiscountPerc' | 'itemDiscount' | 'tax' | 'add' | 'nextRow', index: number) {
        if (type === 'qty') {
            const next = this.qtyInputs.get(index);
            next?.nativeElement.focus();
            setTimeout(() => next.nativeElement.select(), 0);
        } else if (type === 'price') {
            const next = this.costInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'focQty') {
            const next = this.focQtyInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscountPerc') {
            const next = this.itemDiscountPercInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'itemDiscount') {
            const next = this.itemDiscountInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'tax') {
            const next = this.taxInputs.get(index);
            next?.nativeElement.focus();
        } else if (type === 'add') {
            const next = this.addButtons.get(index);
            next?.nativeElement.focus();
        } else if (type === 'nextRow') {
            if (index === this.purchaseDetails.length - 1) {
                this.addRow(index);
                setTimeout(() => {
                    const nextItem = this.itemCodeInputs.get(index + 1);
                    nextItem?.nativeElement.focus();
                });
            } else {
                const nextItem = this.itemCodeInputs.get(index + 1);
                nextItem?.nativeElement.focus();
            }
        }
    }

    addRow(index: number): void {
        if (this.purchaseDetails == null) this.purchaseDetails = [];

        this.purchaseDetail = new CreateOrEditSalesDetailDto();
        this.purchaseDetail.slNo = this.purchaseDetails.length + 1;
        this.purchaseDetail.itemDiscount = 0;
        this.purchaseDetail.itemDiscountPerc = 0;
        this.purchaseDetail.focQty = 0;
        this.purchaseDetail.changeUnitFlag = false;
        this.purchaseDetails.push(this.purchaseDetail);
        const nextItem = this.itemCodeInputs.get(index + 1);
        nextItem?.nativeElement.focus();
    }

    changeUnit(data: any): void {
        data.changeUnitFlag = true;
        this.fillDropDownUnitBasedOnProduct(data.productId, data);
    }

    fillDropDownUnitBasedOnProduct(selectProductId: number, data: CreateOrEditSalesDetailDto): void {
        data.applicableUnits = [];
        this._commonLookupServiceProxy.getUnitForProductCombobox(selectProductId).subscribe({
            next: (result: any) => {
                data.applicableUnits = (result.items || []).map(
                    (x: any) =>
                        new ApplicableUnitForProduct({
                            unitId: x.value,
                            name: x.displayText,
                            numberOfUnits: 0,
                            isBaseUnit: false,
                        }),
                );

                if (!(data.unitId > 0 && data.qty > 0)) {
                    data.unitId = data.unitId;
                    data.unitName = data.unitName;
                }

                let noOfUnits = 1;

                let unitPrice = data.price;

                if (unitPrice > 0) {
                    data.price = unitPrice * noOfUnits;
                } else if (data.price > 0 && noOfUnits > 0) {
                    data.price = data.price / noOfUnits;
                }

                this.amountCalculate(data);
                this.calculateTotalValues();
            },
            error: () => { },
        });
    }

    show(SalesInvoiceId?: number): void {
        if (!SalesInvoiceId) {
            this.salesInvoice = new CreateOrEditSalesDto();
            this.salesInvoice.id = SalesInvoiceId;
            this.salesInvoice.date = this._dateTimeService.getStartOfDay();
            this.salesInvoice.dueDate = this._dateTimeService.getStartOfDay();
            this.customerDisplayProperty = '';
            this.salesInvoice.locationId = this.appSession.user.locationId;
            this.paymentTermName = '';
            this.salesInvoice.taxType = 1;
            this.salesInvoice.status = this.status.Draft;
            this.active = true;
        } else {
            this._SalesInvoicesServiceProxy.getSalesInvoiceForEdit(SalesInvoiceId).subscribe((result) => {
                this.salesInvoice = result.sales;
                this.purchaseDetails = result.salesDetails;
                this.purchaseDetails.forEach((c) => {
                    c.productSelectedItem = new FindProductOutputDto();
                    c.productSelectedItem.id = c.productId;
                    c.productSelectedItem.displayName = c.productName;
                });

                this.customerSelectedItem = new FindCustomerOutputDto();
                this.customerSelectedItem.id = this.salesInvoice.customerId;
                this.customerSelectedItem.displayName = result.customerName;

                this.active = true;

                if (this._activatedRoute.snapshot.queryParams['dirinv'] == 0) {
                    this.salesInvoice.id = null;
                    this.salesInvoice.status = this.status.Draft; 
                    this.salesInvoice.salesId = SalesInvoiceId;
                }
            });
        }
      
        this._commonLookupServiceProxy.getAllPaymentTermForTableDropdown().subscribe((result) => {
            this.allPaymentTerms = result;
        });

        this._commonLookupServiceProxy.getAllTaxes().subscribe((result) => {
            this.applicableTaxes = result;
        });
    }

   
    amountCalculate(data: CreateOrEditSalesDetailDto) {
        var itemDiscount = data.itemDiscount;
        var itemVendorDiscount = 0;

        let qty = data.qty;
        let price = data.price;

        var totalPrice = parseFloat((qty * price).toFixed(2));
        var itemDiscountPerc = 0;
        var itemDiscount = 0;

        if (data.itemDiscountPerc > 0) {
            itemDiscountPerc = (totalPrice * data.itemDiscountPerc) / 100;
        }

        if (data.itemDiscount > 0) {
            itemDiscount = data.itemDiscount;
        }

        data.totalValue = parseFloat((qty * price - itemDiscount - itemDiscountPerc).toFixed(2));
        data.subTotal = parseFloat(data.totalValue.toFixed(2));

        let taxRate = 0;
        if (data.taxId > 0) {
            var tax = this.applicableTaxes.find((p) => p.id == data.taxId);
            taxRate = tax.taxPercentage;
            data.tax = parseFloat(((data.subTotal * taxRate) / 100).toFixed(2));
            data.taxRate = taxRate;
        } else {
            data.tax = 0;
            data.taxRate = 0;
        }
        data.netTotal = parseFloat((data.subTotal + data.tax).toFixed(2));
        this.salesInvoice.roundingAmount = 0;
        this.salesInvoice.otherCharges = 0;
        this.calculateTotalValues();
    }

    calculateTotalValues(): void {
        var data = this.purchaseDetails;
        var tempTotItemDiscount = 0;
        var tempTotItemDiscountPerc = 0;
        var tempTotTotalValue = 0;
        var tempTotSubTotal = 0;
        var tempTotTaxAmt = 0;
        var tempTotNetTotal = 0;
        var tempGrandTotal = 0;
        var totalQty = 0;

        var invoiceNetDiscount = this.salesInvoice.netDiscount;

        this.purchaseDetails.forEach((val) => {
            var itemDiscountPerc = 0;
            var totalPrice = val.qty * val.price;
            var itemDiscountPerc = 0;
            if (val.itemDiscountPerc > 0) {
                itemDiscountPerc = (totalPrice * val.itemDiscountPerc) / 100;
            }

            if (invoiceNetDiscount > 0 && tempTotTotalValue > 0) {
                val.netDiscount = parseFloat(((val.totalValue * invoiceNetDiscount) / tempTotTotalValue).toFixed(2));
                val.subTotal = parseFloat(
                    (val.totalValue - (val.totalValue * invoiceNetDiscount) / tempTotTotalValue).toFixed(2),
                );
            } else {
                val.netDiscount = 0;
                val.subTotal = val.totalValue;
            }

            tempTotItemDiscount = tempTotItemDiscount + val.itemDiscount;
            tempTotItemDiscountPerc = tempTotItemDiscountPerc + itemDiscountPerc;
            tempTotTotalValue = tempTotTotalValue + val.totalValue;
            if (val.qty != 0) {
                totalQty = totalQty + val.qty;
            }

            var taxamt = 0;
            if (this.salesInvoice.taxType == 1) {
                taxamt = parseFloat(((val.subTotal * val.taxRate) / 100).toFixed(2));
            } else if (this.salesInvoice.taxType == 2) {
                var actualTotal = val.subTotal;
                if (actualTotal > 0) taxamt = (actualTotal * val.taxRate) / (val.taxRate + 100);
            }
            val.tax = parseFloat(taxamt.toFixed(2));
            if (this.salesInvoice.taxType == 2) {
                val.netTotal = val.subTotal;
                val.subTotal = val.netTotal - val.tax;
            } else {
                val.netTotal = val.subTotal + val.tax;
            }

            val.netTotal = val.subTotal + val.tax;
            tempTotSubTotal = tempTotSubTotal + val.subTotal;
            tempTotTaxAmt = tempTotTaxAmt + val.tax;
            tempTotNetTotal = tempTotNetTotal + val.netTotal;
        });

        this.salesInvoice.itemDiscount = tempTotItemDiscount;
        this.salesInvoice.netDiscountPerc = tempTotItemDiscountPerc;
        this.salesInvoice.totalValue = tempTotTotalValue;
        this.salesInvoice.subTotal = tempTotSubTotal;
        this.salesInvoice.tax = tempTotTaxAmt;
        this.salesInvoice.netTotal = parseFloat((this.salesInvoice.subTotal + this.salesInvoice.tax).toFixed(2));
        this.salesInvoice.totalQty = totalQty;

        if (this.salesInvoice.netDiscount > 0 && this.salesInvoice.netDiscount > tempTotTotalValue) {
            abp.notify.warn('DiscountInvoiceErr');
            this.salesInvoice.netDiscount = 0;
        }

        if (this.salesInvoice.roundingAmount > 0 && this.salesInvoice.roundingAmount > tempTotSubTotal) {
            abp.notify.warn('RoundedAmountInvoiceErr');
            this.salesInvoice.roundingAmount = 0;
        }

        tempGrandTotal =
            this.salesInvoice.netTotal +
            Number(this.salesInvoice.otherCharges) +
            Number(this.salesInvoice.roundingAmount);
        this.salesInvoice.grandTotal = parseFloat(tempGrandTotal.toFixed(2));
    }

    save(status: any): void {
        this.saving = true;

        this.salesInvoice.status = status;
        var salesInput = new GetSalesForEditInput();
        salesInput.sales = this.salesInvoice;
        
        salesInput.salesDetails = this.purchaseDetails;

        if (!(this.salesInvoice.customerId > 0)) {
            abp.notify.warn('PleaseSelCustomer');
            this.saving = false;
            return;
        }

        this._SalesInvoicesServiceProxy
            .createOrEdit(salesInput)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this._router.navigate(['/app/sales/salesInvoices']);
            });
    }

    getProduct(product: FindProductOutputDto, data: CreateOrEditSalesDetailDto, index: number) {
        this.productSelectedItem = product;
        this.purchaseDetails[index].productSelectedItem = product;
        this.searchProduct(product.code, data, index);
    }

    getCustomer(customer: FindCustomerOutputDto) {
        this.salesInvoice.customerId = customer.id;
        this.salesInvoice.paymentTermId = customer.paymentTermId;
    }

    goBack(): void {
        this._router.navigate(['/app/sales/salesInvoices']);
    }
}
